import React, { useState, useEffect, memo, Fragment, useCallback, useRef } from 'react'
import { Row, Col, Collapse, Button, Card, Modal, Form } from 'react-bootstrap'
import { Table, message, DatePicker, Radio, Spin, AutoComplete, Input, Select, Switch, Segmented, Tooltip } from 'antd';
import { DownOutlined, UpOutlined, ArrowRightOutlined, SearchOutlined } from "@ant-design/icons"
import { GetLatestStdCertificateDataService, getDashboardReportSummaryData, GetReturnsDataService, downloadPendencySummary, downloadDashboardReportService, getAllAdminIECsService } from '../../services/FileDataService';
import { sendConsultationRequest, userRbac } from '../../services/UserService';
import { searchHscodeOnly, searchHscodeAutocomplete, searchTradeData } from '../../services/TradeService';
import debounce from 'lodash/debounce';
import '../../assets/scss/dashboard.scss';
import { useNavigate, useLocation } from 'react-router-dom'
import Progress from '../../components/progress';
import { formatToTwoDecimals } from '../../utilities/utils';
import dayjs from 'dayjs';
import Loader from '../../components/Loader';


// Redux Selector / Action
import { useSelector } from 'react-redux';

// Import selectors & action from setting store
import * as SettingSelector from '../../store/setting/selectors'

//Count-up
import SubHeader from '../../components/partials/dashboard/headerstyle/sub-header';
import moment from 'moment';

const Index = memo((props) => {
    useSelector(SettingSelector.theme_color)
    const navigate = useNavigate();
    const location = useLocation();
    const [userDetails, setUserDetails] = useState({
        role: localStorage.getItem('role'),
        iec: localStorage.getItem('iec_no'),
        name: localStorage.getItem('name')
    })
    const [IECOptions, setIECOptions] = useState([]);
    const [selectedIEC, setSelectedIEC] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState();
    const [hoveredText, setHoveredText] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);

    // date
    const currentYear = dayjs().year();
    const defaultFrom = dayjs(`${currentYear}-01-01`);
    const defaultTo = dayjs(`${currentYear}-12-31`);
    const [dates, setDates] = useState([defaultFrom, defaultTo]);
    const [isValid, setIsValid] = useState(true);
    const [mode, setMode] = useState('year');
    const [selectedCurrency, setSelectedCurrency] = useState('INR');
    const [selectedYear, setSelectedYear] = useState(dayjs());
    const [cooCosFilter, setCooCosFilter] = useState("ALL");
    const [categoryRemarkFilter, setCategoryRemarkFilter] = useState("ALL");

    const [returnData, setReturnData] = useState([]);

    const [consultationForm, setConsultationForm] = useState({
        iec_name: userDetails?.name || "",
        name: "",
        contact_no: "",
        subject: "",
        message: "",
        email: "",
        iec: userDetails?.iec || ""
    });

    const [openCollapse, setOpenCollapse] = useState({
        "EDPMS": false,
        "DBK-AIR": false,
        "RODTEP-Exp": false,
        "AdvAuth-EO": false,
        "IGST-Refund": false,
        "EPCG-Auth-EO": false,
        "FTA-Opportunity": false,
        "FTA-Applicability": false,
        "Bond-Utilization": false,
        "Rodtep-Util": false,
        "AdvAuth-Utilization": false,
        "AdvAuthExcessImportLiab": false,
        "TAT-ImportClearance": false,
        "TAT-ExportClearance": false,
        "Summary-Imp": false,
        "Summary-Exp": false,
        "IDPMS": false,
        "IMP-DUTY-RATE": false,
        "CCR": false,
        "Inconsistency": false
    })

    const [summaryDashboardData, setSummaryDashboardData] = useState({});

    // IEC Comparison State
    const [activeCompareIecs, setActiveCompareIecs] = useState({});
    const [comparisonData, setComparisonData] = useState({});
    const [isComparingData, setIsComparingData] = useState({});

    // Compliance tab RBAC state
    // null  → not yet fetched / no COMPLIANCE rows configured → show all tabs
    // Set   → only show tabs whose page_desc is in this Set
    const [allowedComplianceTabs, setAllowedComplianceTabs] = useState(null);


    // Sync Ref for selectedIEC to handle rapid multi-clicks
    const selectedIecRef = useRef(selectedIEC);
    useEffect(() => {
        selectedIecRef.current = selectedIEC;
    }, [selectedIEC]);

    // IMP DUTY RATE Modal State
    const [showImpDutyModal, setShowImpDutyModal] = useState(false);
    const [impDutyHscode, setImpDutyHscode] = useState("");
    const [impDutyHscodeOptions, setImpDutyHscodeOptions] = useState([]);
    const [impDutyAssessableValue, setImpDutyAssessableValue] = useState(100);
    const [impDutyLoading, setImpDutyLoading] = useState(false);

    const [selectedMode, setSelectedMode] = useState("All");

    const fetchImpDutyHscodeOptions = useCallback(
        debounce(async (searchText) => {
            if (!searchText || searchText.length < 2) {
                setImpDutyHscodeOptions([]);
                return;
            }
            try {
                const results = await searchHscodeAutocomplete(searchText);
                const options = results.map(item => ({
                    value: item,
                    label: item
                }));
                setImpDutyHscodeOptions(options);
            } catch (error) {
                console.error('Autocomplete error:', error);
                setImpDutyHscodeOptions([]);
            }
        }, 300),
        []
    );

    const handleImpDutyHscodeChange = (value) => {
        setImpDutyHscode(value);
        fetchImpDutyHscodeOptions(value);
    };

    const handleImpDutyHscodeSelect = (value) => {
        setImpDutyHscode(value);
        setImpDutyHscodeOptions([]);
    };

    const handleClose = () => setShowModal(false);
    const handleShow = (type) => {
        setModalType(type);
        setShowModal(true);
    };

    const handleImpDutyModalOpen = () => {
        setShowImpDutyModal(true);
        setImpDutyHscode('');
        setImpDutyHscodeOptions([]);
        setImpDutyAssessableValue(100);
    };

    const handleImpDutyModalClose = () => {
        setShowImpDutyModal(false);
        setImpDutyHscode('');
        setImpDutyHscodeOptions([]);
        setImpDutyAssessableValue('');
    };

    const handleImpDutySearch = async (e) => {
        e.preventDefault();
        if (!impDutyHscode) {
            message.error("Please enter HS Code");
            return;
        }

        setImpDutyLoading(true);
        try {
            if (impDutyAssessableValue) {
                const result = await searchTradeData(impDutyHscode, impDutyAssessableValue);
                handleImpDutyModalClose();
                navigate('/dashboard/trade-search', {
                    state: {
                        hscode: impDutyHscode,
                        assessableValue: impDutyAssessableValue,
                        fullSearchResult: result
                    }
                });
            } else {
                const result = await searchHscodeOnly(impDutyHscode);
                handleImpDutyModalClose();
                navigate('/dashboard/trade-search', {
                    state: {
                        hscode: impDutyHscode,
                        generalData: result
                    }
                });
            }
        } catch (error) {
            message.error(typeof error === 'string' ? error : 'Search failed');
        } finally {
            setImpDutyLoading(false);
        }
    };

    const showCollapseCard = (names) => {
        if (!isValid || dates.length !== 2) {
            message.error("Please select a valid date range.");
            return;
        }

        // Convert single name to array for consistent handling
        const cardNames = Array.isArray(names) ? names : [names];

        setOpenCollapse(prevState => {
            // Check if ANY of the requested cards is currently closed
            const anyCardClosed = cardNames.some(name => !prevState[name]);

            // Create a new state object with all values set to false
            const newState = Object.keys(prevState).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});

            // If any card was closed, open all requested cards and fetch data
            // If all were open, they'll all be closed (toggle behavior)
            if (anyCardClosed) {
                cardNames.forEach(name => {
                    if (!prevState[name]) {
                        getSummaryDashboard(name);
                    }
                    newState[name] = true;
                });
            }

            return newState;
        });
    }

    const [stdCertData, setStdCertData] = useState({})

    const today = moment();
    const nextMarch31 = today.isAfter(moment(`${currentYear}-03-31`))
        ? moment(`${currentYear + 1}-03-31`)
        : moment(`${currentYear}-03-31`);
    const daysLeft = nextMarch31.diff(today, 'days');
    const expiryDate = nextMarch31.format('MMMM Do, YYYY');

    const getVariableColor = () => {
        let prefix = getComputedStyle(document.body).getPropertyValue('--prefix') || 'bs-';
        if (prefix) {
            prefix = prefix.trim()
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(`--${prefix}primary`);
        const color2 = getComputedStyle(document.body).getPropertyValue(`--${prefix}info`);
        const color3 = getComputedStyle(document.body).getPropertyValue(`--${prefix}primary-tint-20`);
        const color4 = getComputedStyle(document.body).getPropertyValue(`--${prefix}warning`);
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    }
    const variableColors = getVariableColor();
    const colors = [variableColors.primary, variableColors.info];

    var subHeader = "";
    subHeader = <SubHeader />;

    useEffect(() => {
        return () => colors
    })

    const refreshActiveComparisons = (cardName, newDates) => {
        const activeIecs = activeCompareIecs[cardName] || [];
        if (activeIecs.length === 0) return;

        const date_filters = {
            from_date: newDates?.[0] ? dayjs(newDates[0]).format("YYYY-MM-DD") : null,
            to_date: newDates?.[1] ? dayjs(newDates[1]).format("YYYY-MM-DD") : null,
        };

        // Clear cached data so UI goes back to a loading state
        setComparisonData(prev => ({
            ...prev,
            [cardName]: {}
        }));

        activeIecs.forEach(async (iec) => {
            setIsComparingData(prev => ({
                ...prev,
                [cardName]: { ...(prev[cardName] || {}), [iec]: true }
            }));

            try {
                const response = await getDashboardReportSummaryData(cardName, date_filters, iec);
                if (response?.data?.[cardName]) {
                    const data = response.data[cardName];
                    if (data.headers) {
                        data.headers.filter(h => h.dataIndex === "summary" || h.dataIndex === "percentage").forEach(column => {
                            column.render = (text, record) => (
                                <span style={{ color: record.color, fontSize: "13px" }}>
                                    <b>{text}{column.dataIndex === 'percentage' ? '%' : ''}</b>
                                </span>
                            );
                        });
                    }
                    setComparisonData(prev => ({
                        ...prev,
                        [cardName]: {
                            ...(prev[cardName] || {}),
                            [iec]: data
                        }
                    }));
                }
            } catch (err) {
                console.error("Failed to re-fetch comparison data:", err);
            } finally {
                setIsComparingData(prev => ({
                    ...prev,
                    [cardName]: { ...(prev[cardName] || {}), [iec]: false }
                }));
            }
        });
    };

    const handleYearChange = (value) => {
        setSelectedYear(value);
        setIsValid(!!value);
        let newDates = [];
        if (value) {
            const from_date = value.startOf('year');
            const to_date = value.endOf('year');
            newDates = [from_date, to_date];
            setDates(newDates);
        } else {
            setDates([]);
        }

        // Auto-refresh data if a card is open when year changes
        const openCard = Object.keys(openCollapse).find(k => openCollapse[k]);
        if (openCard && newDates.length === 2) {
            getSummaryDashboard(openCard, newDates);
            refreshActiveComparisons(openCard, newDates);
            message.success("Selection updated.");
        }
    };

    const handleSubmit = () => {
        if (mode === 'dates' && (!isValid || dates.length !== 2)) {
            message.error("Please select a valid date range.");
            return;
        }
        if (mode === 'year' && !selectedYear) {
            message.error("Please select a year.");
            return;
        }

        // Find all open cards and refresh them
        const openCards = Object.keys(openCollapse).filter(k => openCollapse[k]);
        if (openCards.length > 0) {
            openCards.forEach(card => {
                getSummaryDashboard(card, dates);
                refreshActiveComparisons(card, dates);
                message.success("Selection updated.");
            });
        } else {
            message.info("No cards are currently open.");
        }
    };

    const serializedDates = dates && dates.length === 2
        ? [dayjs(dates[0]).format("YYYY-MM-DD"), dayjs(dates[1]).format("YYYY-MM-DD")]
        : [];

    const getAdminIEC = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await getAllAdminIECsService(token);
            if (response?.data) {
                const options = response.data.map((item, index) => ({
                    value: item.iec_no,
                    label: `(${item.fullname})`,
                    key: index,
                }));
                setIECOptions(options);
            }
        } catch (err) {
            console.error('Failed to load IEC list', err);
        }
    };

    const getSummaryDashboard = async (complianceType, dateRange, cooCosOverride, iecOverride = null, categoryRemarkOverride = undefined) => {
        const range = dateRange || dates;
        const date_filters = {
            from_date: range?.[0] ? dayjs(range[0]).format("YYYY-MM-DD") : null,
            to_date: range?.[1] ? dayjs(range[1]).format("YYYY-MM-DD") : null,
            coo_cos: cooCosOverride !== undefined ? cooCosOverride : cooCosFilter,
            category_remark: categoryRemarkOverride !== undefined ? categoryRemarkOverride : categoryRemarkFilter
        };

        const targetIec = iecOverride || selectedIecRef.current;

        try {
            setIsLoading2(true)
            const apiComplianceType = complianceType;
            const response = await getDashboardReportSummaryData(apiComplianceType, date_filters, targetIec);

            if (response) {
                if (response.data) {
                    Object.keys(response.data).forEach((key) => {
                        const data = response.data[key];

                        if (data && data["headers"]) {
                            const headers = data["headers"];

                            // Find the object with dataIndex = "summary" or any index containing "percentage" or "percent"
                            const isPercentageColumn = (index) =>
                                index && (index.toLowerCase().includes("percentage") || index.toLowerCase().includes("percent"));

                            const targetObject = headers.filter(header => header.dataIndex === "summary" || isPercentageColumn(header.dataIndex));
                            if (targetObject) {
                                targetObject.forEach(column => {
                                    // Add the 'render' function to the found object
                                    column.render = (text, record) => (
                                        <span style={{ color: record.color, fontSize: "13px" }}>
                                            <b>{text}{isPercentageColumn(column.dataIndex) ? '%' : ''}</b>
                                        </span>
                                    );
                                })
                            }
                        }
                    });

                    setSummaryDashboardData(prevData => ({
                        ...prevData,
                        ...response.data
                    }));
                }
            } else {
                console.log("getSummaryDashboard :: no response")
            }
            setIsLoading2(false)
        }
        catch (err) {
            setIsLoading2(false)
            console.log(err);
        }
    }

    const toggleCompareIec = async (cardName, iecToToggle) => {
        const toggleDateRange = dates;
        const date_filters = {
            from_date: toggleDateRange?.[0] ? dayjs(toggleDateRange[0]).format("YYYY-MM-DD") : null,
            to_date: toggleDateRange?.[1] ? dayjs(toggleDateRange[1]).format("YYYY-MM-DD") : null,
        };

        const currentActive = activeCompareIecs[cardName] || [];

        if (currentActive.includes(iecToToggle)) {
            // Immediately remove from active list AND clear cached data so table reverts instantly
            setActiveCompareIecs(prev => ({
                ...prev,
                [cardName]: (prev[cardName] || []).filter(iec => iec !== iecToToggle)
            }));
            setComparisonData(prev => {
                const updated = { ...(prev[cardName] || {}) };
                delete updated[iecToToggle];
                return { ...prev, [cardName]: updated };
            });
        } else {
            setActiveCompareIecs(prev => ({
                ...prev,
                [cardName]: [...(prev[cardName] || []), iecToToggle]
            }));

            // Always fetch fresh data on toggle-on so the latest backend config
            // (group head's page_config thresholds) is always reflected immediately.
            setIsComparingData(prev => ({
                ...prev,
                [cardName]: { ...(prev[cardName] || {}), [iecToToggle]: true }
            }));

            try {
                const response = await getDashboardReportSummaryData(cardName, date_filters, iecToToggle);
                if (response && response.data && response.data[cardName]) {
                    const data = response.data[cardName];
                    if (data.headers) {
                        const targetObject = data.headers.filter(h => h.dataIndex === "summary" || h.dataIndex === "percentage");
                        targetObject.forEach(column => {
                            column.render = (text, record) => (
                                <span style={{ color: record.color, fontSize: "13px" }}>
                                    <b>{text}{column.dataIndex === 'percentage' ? '%' : ''}</b>
                                </span>
                            );
                        });
                    }
                    setComparisonData(prev => ({
                        ...prev,
                        [cardName]: {
                            ...(prev[cardName] || {}),
                            [iecToToggle]: data
                        }
                    }));
                } else {
                    message.warning(`No data found for ${iecToToggle}`);
                }
            } catch (err) {
                console.error("Failed to fetch comparison data:", err);
                message.error(`Failed to load data for ${iecToToggle}`);
            } finally {
                setIsComparingData(prev => ({
                    ...prev,
                    [cardName]: { ...(prev[cardName] || {}), [iecToToggle]: false }
                }));
            }
        }
    };

    const renderAdminSummary = (cardName) => {
        const rawData = summaryDashboardData[cardName];
        if (isLoading2 && !rawData) {
            return (
                <div className="d-flex justify-content-center p-4">
                    <Spin size="large" />
                </div>
            );
        }
        if (!rawData) return null;

        const isMultiMode = !rawData.dashboard_summary && (rawData.All || rawData.Sea || rawData.Air || rawData.Land);

        const renderTable = (headers, data, title = null) => {
            // Dynamically adjust headers based on selected currency
            const adjustedHeaders = headers.map(header => {
                const isPendencyReport = cardName === 'Summary-Imp' || cardName === 'Summary-Exp';
                const monetaryColumns = [
                    'total_amount', 'amount', 'total_fob_value', 'eo_fulfilled_val', 'bal_eo_val', 'bal_eo_value',
                    'rodtep_scrip_amount', 'balance_amt', 'bcd_availed', 'bcd_missed_opp', 'total_eligible'
                ];

                const isMonetary = monetaryColumns.includes(header.dataIndex);

                if (selectedCurrency === 'USD') {
                    if (header.dataIndex === 'summary' && isPendencyReport) {
                        return {
                            ...header,
                            title: cardName === 'Summary-Imp' ? 'BOE Count' : 'SHB Count',
                            render: (text, record) => (
                                <span style={{ color: record.color, fontSize: "13px" }}>
                                    <b>{text}</b>
                                </span>
                            )
                        };
                    }

                    if (isMonetary) {
                        const usdKey = `${header.dataIndex}_usd`;
                        return {
                            ...header,
                            title: `${header.title} ($)`,
                            dataIndex: usdKey,
                            render: (text, record) => (
                                <span style={{ color: record.color, fontSize: "13px" }}>
                                    <b>${Number(record[usdKey] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                </span>
                            )
                        };
                    }

                    if (!isPendencyReport && /^\d{4}$/.test(header.dataIndex)) {
                        return {
                            ...header,
                            dataIndex: `${header.dataIndex}_amount_usd`,
                            render: (text, record) => (
                                <span style={{ color: record.color, fontSize: "13px" }}>
                                    <b>${Number(text || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                </span>
                            )
                        };
                    }
                } else {
                    // INR Mode
                    if (isMonetary) {
                        return {
                            ...header,
                            title: `${header.title} (₹)`,
                            render: (text, record) => (
                                <span style={{ color: record.color, fontSize: "13px" }}>
                                    <b>₹{Number(text || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                </span>
                            )
                        };
                    }
                }
                return header;
            });

            return (
                <div className="mt-2 mb-3" key={title || 'single'}>
                    {title && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                            <div style={{ width: '4px', height: '18px', backgroundColor: '#25dbcd', borderRadius: '2px' }}></div>
                            <span style={{ fontWeight: '700', fontSize: '14px', color: '#4b5563', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Mode: {title}
                            </span>
                        </div>
                    )}
                    <div className="table-responsive">
                        <Table
                            className="dash-summary-table m-0"
                            columns={adjustedHeaders}
                            dataSource={data}
                            pagination={false}
                            size="small"
                            bordered
                            loading={isLoading2}
                            scroll={{ x: 'max-content' }}
                        />
                    </div>
                </div>
            );
        };

        if (isMultiMode) {
            const availableModes = ['All', 'Sea', 'Air', 'Land'].filter(m => rawData[m]);
            const currentMode = availableModes.includes(selectedMode) ? selectedMode : availableModes[0];
            const modeData = rawData[currentMode];

            return (
                <div className="multi-mode-container mt-2">
                    <div className="mb-3">
                        <Radio.Group
                            value={currentMode}
                            onChange={(e) => setSelectedMode(e.target.value)}
                            buttonStyle="solid"
                            size="small"
                        >
                            {availableModes.map(mode => (
                                <Radio.Button key={mode} value={mode}>{mode}</Radio.Button>
                            ))}
                        </Radio.Group>
                    </div>
                    {modeData && modeData.headers && modeData.dashboard_summary && (
                        renderTable(modeData.headers, modeData.dashboard_summary, currentMode)
                    )}
                </div>
            );
        }

        if (!rawData.headers || !rawData.dashboard_summary) {
            return null;
        }

        return renderTable(rawData.headers, rawData.dashboard_summary);
    }

    const downloadFullSummaryReport = async (reportCardName) => {
        try {
            setIsLoading2(true);
            const token = localStorage.getItem('token');
            const fileType = reportCardName === 'Summary-Imp' ? 'BOE' : 'SHB';
            const isImport = reportCardName === 'Summary-Imp';
            const reportTitle = isImport ? 'Import Summary' : 'Export Summary';
            message.loading({ content: `Downloading ${reportTitle} Report...`, key: 'summary_dl' });
            const iec = selectedIEC || userDetails.iec || 'ALL';
            let response;
            try {
                response = await downloadDashboardReportService(reportCardName, iec, 'ALL');
            } catch (e1) {
                response = await downloadPendencySummary(token, fileType);
            }
            if (response && response.data) {
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const timestamp = new Date().toISOString().split('T')[0];
                const safeTitle = isImport ? 'Import_Summary_Report' : 'Export_Summary_Report';
                link.setAttribute('download', `${safeTitle}_${timestamp}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                message.success({ content: `${reportTitle} Report downloaded successfully!`, key: 'summary_dl' });
            }
        } catch (error) {
            console.error('Download failed:', error);
            message.error({ content: 'Failed to download report. Please try again.', key: 'summary_dl' });
        } finally {
            setIsLoading2(false);
        }
    };

    const renderCompareIecs = (cardName) => {
        if (userDetails.role === 'admin' || userDetails.role === 'user') {
            return renderAdminSummary(cardName)
        }
        if (userDetails.role !== 'group_head' || !IECOptions || IECOptions.length === 0) return null;

        const reportRoutes = {
            'DBK-AIR': '/dashboard/reports/drawback-report',
            'AdvAuth-EO': '/dashboard/reports/advauth-export-report',
            'EPCG-Auth-EO': '/dashboard/reports/epcg-report',
            'RODTEP-Exp': '/dashboard/reports/rodtep-export-report',
            'IGST-Refund': '/dashboard/reports/igst-report',
            // 'Summary-Imp': '/dashboard/report-templates/create?__report__=REPORT_BOE',
            // 'Summary-Exp': '/dashboard/report-templates/create?__report__=REPORT_SHB',
            'IDPMS': '/dashboard',
            'EDPMS': '/dashboard/reports/brc-report',
        };
        const targetRoute = reportRoutes[cardName] || null;

        const activeIecs = activeCompareIecs[cardName] || [];
        const isMaxReached = false; // Limit removed as per user request

        // Get display label for an IEC column header (Company Name)
        const getIecLabel = (iec) => {
            const opt = IECOptions.find(o => o.value === iec);
            const labelMatch = opt?.label?.match(/\((.+)\)/);
            if (labelMatch) {
                // The label is often configured as "COMPANY NAME - ALIAS" or similar inside parentheses
                const parts = labelMatch[1].split('-');
                return parts.length > 1 ? parts.pop().trim() : labelMatch[1].trim();
            }
            return iec;
        };

        // Build a single unified side-by-side table filling full width
        const buildUnifiedTable = (mode = null) => {
            const rawData = summaryDashboardData[cardName];
            if (!rawData) return null;

            const isMultiMode = !rawData.dashboard_summary && (rawData.All || rawData.Sea || rawData.Air || rawData.Land);
            const mainData = isMultiMode ? rawData[mode] : rawData;
            if (!mainData) return <div className="text-muted p-2">No data for {mode}</div>;

            // Normalize rows because some reports like IDPMS use 'remark' instead of 'description', 
            // and others like FTA use 'business_unit'.
            const normalizeRows = (rows) => (rows || []).map(r => ({ ...r, description: r.description || r.remark || r.business_unit || '' }));
            const baseRows = normalizeRows(mainData?.dashboard_summary);
            const headers = mainData?.headers || [];

            // Identify data columns (skip description/remark, color, percentage, key)
            const dataColumns = headers.filter(h =>
                !['description', 'remark', 'color', 'key'].includes(h.dataIndex)
            );

            const activeIecs = activeCompareIecs[cardName] || [];
            const anyLoading = activeIecs.some(iec => isComparingData[cardName]?.[iec]);

            // Show combined percentage for all cards
            const showCombinedPercentage = true;

            // Description column
            const unifiedColumns = [
                {
                    title: 'Description',
                    dataIndex: 'description',
                    key: 'description',
                    fixed: 'left',
                    width: 200,
                }
            ];

            const monetaryColumns = [
                'total_amount', 'amount', 'total_fob_value', 'eo_fulfilled_val', 'bal_eo_val', 'bal_eo_value',
                'rodtep_scrip_amount', 'balance_amt', 'bcd_availed', 'bcd_missed_opp', 'total_eligible'
            ];

            // For each active IEC, add all data columns
            activeIecs.forEach(iec => {
                dataColumns.forEach(col => {
                    const isPct = col.dataIndex && (col.dataIndex.toLowerCase().includes("percentage") || col.dataIndex.toLowerCase().includes("percent"));
                    const isPendencyReport = cardName === 'Summary-Imp' || cardName === 'Summary-Exp';
                    const isMonetary = monetaryColumns.includes(col.dataIndex);

                    let dataIndex = `${iec}_${col.dataIndex}`;
                    let title = col.title;
                    let renderValue = (text) => text;

                    if (selectedCurrency === 'USD') {
                        if (col.dataIndex === 'summary' && isPendencyReport) {
                            title = cardName === 'Summary-Imp' ? 'BOE Count' : 'SHB Count';
                        } else if (isMonetary) {
                            dataIndex = `${iec}_${col.dataIndex}_usd`;
                            title = `${col.title} ($)`;
                            renderValue = (text, record) => `$${Number(record[dataIndex] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        } else if (!isPendencyReport && /^\d{4}$/.test(col.dataIndex)) {
                            // Year columns for amount-based reports
                            dataIndex = `${iec}_${col.dataIndex}_amount_usd`;
                            renderValue = (text, record) => `$${Number(record[dataIndex] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        }
                    } else {
                        // INR Mode
                        if (isMonetary) {
                            title = `${col.title} (₹)`;
                            renderValue = (text, record) => `₹${Number(record[dataIndex] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        }
                    }

                    unifiedColumns.push({
                        title: (
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '10px', color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={getIecLabel(iec)}>
                                    {getIecLabel(iec)}
                                </div>
                                <div style={{ fontSize: '11px', fontWeight: 'bold' }}>{title}</div>
                            </div>
                        ),
                        key: `${iec}_${col.dataIndex}_${selectedCurrency}`,
                        dataIndex: dataIndex,
                        align: 'center',
                        width: 120,
                        render: (text, record) => (
                            <span style={{ color: record[`${iec}_color`] || 'inherit', fontSize: '13px' }}>
                                <b>
                                    {isComparingData[cardName]?.[iec]
                                        ? <Spin size="small" />
                                        : (isMonetary || (!isPendencyReport && /^\d{4}$/.test(col.dataIndex))) ? renderValue(text, record) : (text ?? '-')}
                                    {(!isComparingData[cardName]?.[iec] && text !== null && text !== undefined && isPct) ? '%' : ''}
                                </b>
                            </span>
                        ),
                    });
                });
            });

            // If no IECs selected (e.g. ALL mode), show base data columns with matching currency formatting
            if (activeIecs.length === 0) {
                dataColumns.forEach(col => {
                    const isPct = col.dataIndex && (col.dataIndex.toLowerCase().includes("percentage") || col.dataIndex.toLowerCase().includes("percent"));
                    const isPendencyReport = cardName === 'Summary-Imp' || cardName === 'Summary-Exp';
                    const isMonetary = monetaryColumns.includes(col.dataIndex);

                    let dataIndex = col.dataIndex;
                    let title = col.title;
                    let renderValue = (text) => text;

                    if (selectedCurrency === 'USD') {
                        if (col.dataIndex === 'summary' && isPendencyReport) {
                            title = cardName === 'Summary-Imp' ? 'BOE Count' : 'SHB Count';
                        } else if (isMonetary) {
                            dataIndex = `${col.dataIndex}_usd`;
                            title = `${col.title} ($)`;
                            renderValue = (text, record) => `$${Number(record[dataIndex] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        } else if (!isPendencyReport && /^\d{4}$/.test(col.dataIndex)) {
                            // Year columns for amount-based reports
                            dataIndex = `${col.dataIndex}_amount_usd`;
                            renderValue = (text, record) => `$${Number(record[dataIndex] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        }
                    } else {
                        // INR Mode
                        if (isMonetary) {
                            title = `${col.title} (₹)`;
                            renderValue = (text, record) => `₹${Number(record[dataIndex] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        }
                    }

                    unifiedColumns.push({
                        title: title,
                        key: col.key || col.dataIndex,
                        dataIndex: dataIndex,
                        align: 'center',
                        width: 120,
                        render: (text, record) => (
                            <span style={{ color: record.color || 'inherit', fontSize: '13px' }}>
                                <b>
                                    {(isMonetary || (!isPendencyReport && /^\d{4}$/.test(col.dataIndex))) ? renderValue(text, record) : (text ?? '-')}
                                    {(text !== null && text !== undefined && isPct) ? '%' : ''}
                                </b>
                            </span>
                        ),
                    });
                });
            }

            // Ratio-based cards carry no count column, so their Combined % is the pooled
            // ratio across the compared IECs (sum of numerators / sum of denominators),
            // matching each card's own Percentage column rather than a share of row counts.
            const combinedRatioFields = {
                'FTA-Opportunity': ['bcd_availed', 'total_eligible'],
                'FTA-Applicability': ['missed_coo', 'applicable_coo_count'],
            };

            // Add combined percentage at the end
            if (showCombinedPercentage) {
                unifiedColumns.push({
                    title: 'Combined %',
                    dataIndex: 'combined_percentage',
                    key: 'combined_percentage',
                    align: 'center',
                    width: 100,
                    fixed: 'right',
                    render: (text, record) => {
                        const color = activeIecs.length > 0
                            ? (activeIecs.map(iec => record[`${iec}_color`]).find(Boolean) || 'inherit')
                            : (record.color || 'inherit');

                        const ratioFields = combinedRatioFields[cardName];
                        if (ratioFields) {
                            const [numField, denField] = ratioFields;
                            const prefixes = activeIecs.length > 0 ? activeIecs.map(iec => `${iec}_`) : [''];
                            const num = prefixes.reduce((acc, p) => acc + (parseFloat(record[`${p}${numField}`]) || 0), 0);
                            const den = prefixes.reduce((acc, p) => acc + (parseFloat(record[`${p}${denField}`]) || 0), 0);
                            const ratioPct = den > 0 ? ((num / den) * 100).toFixed(2) : '0.00';
                            return (
                                <span style={{ color, fontSize: '13px' }}>
                                    <b>{ratioPct}%</b>
                                </span>
                            );
                        }

                        // Sum across compared IECs (or just use base if none selected)
                        const totalList = activeIecs.length > 0
                            ? activeIecs.map(iec => parseFloat(record[`${iec}_summary`]) || parseFloat(record[`${iec}_count`]) || 0)
                            : [parseFloat(record.summary) || parseFloat(record.count) || 0];

                        const total = totalList.reduce((a, b) => a + b, 0);

                        // Find grand totals for percentage calculation.
                        // Sum ALL rows instead of looking for a 'total' row — reports like
                        // TAT-ImportClearance have no explicit total row, so summing all
                        // counts gives the correct denominator for every report type.
                        const grandTotalList = activeIecs.length > 0
                            ? activeIecs.map(iec => {
                                const iecFullData = comparisonData[cardName]?.[iec];
                                const iecData = isMultiMode ? iecFullData?.[mode] : iecFullData;
                                const iecRows = normalizeRows(iecData?.dashboard_summary);
                                return iecRows.reduce((acc, r) =>
                                    acc + (parseFloat(r.summary) || parseFloat(r.count) || parseFloat(r.remark_count) || 0), 0);
                            })
                            : [baseRows.reduce((acc, r) =>
                                acc + (parseFloat(r.summary) || parseFloat(r.count) || parseFloat(r.remark_count) || 0), 0)];

                        const grandTotal = grandTotalList.reduce((a, b) => a + b, 0);

                        const pct = grandTotal > 0 ? ((total / grandTotal) * 100).toFixed(2) : '0.00';

                        return (
                            <span style={{ color, fontSize: '13px' }}>
                                <b>{pct}%</b>
                            </span>
                        );
                    },
                });
            }

            // Determine the definitive row list:
            // - When IECs are actively compared, collect a clean UNION of all row
            //   descriptions (ordered by first appearance across IECs).  Because the
            //   backend now always loads page_config from the group head's own IEC,
            //   every comparison request returns the same bucket labels, so a simple
            //   union is always correct — no orphan rows will appear.
            // - When no IECs are selected (ALL view), use the base rows unchanged.
            let sourceRows;
            if (activeIecs.length > 0) {
                const iecDescSet = new Set();
                const iecDescOrder = [];
                activeIecs.forEach(iec => {
                    const iecFullData = comparisonData[cardName]?.[iec];
                    const iecData = isMultiMode ? iecFullData?.[mode] : iecFullData;
                    const iecRows = normalizeRows(iecData?.dashboard_summary);
                    iecRows.forEach(r => {
                        if (!iecDescSet.has(r.description)) {
                            iecDescSet.add(r.description);
                            iecDescOrder.push(r.description);
                        }
                    });
                });

                sourceRows = iecDescOrder.map(desc => {
                    const baseRow = baseRows.find(r => r.description === desc);
                    return baseRow ? { ...baseRow } : { description: desc };
                });
            } else {
                sourceRows = baseRows.map(r => ({ ...r }));
            }

            // Merge each active IEC's values into the source rows
            const unifiedRows = sourceRows.map((row, index) => {
                const merged = { ...row, key: row.key || index };
                activeIecs.forEach((iec) => {
                    const iecFullData = comparisonData[cardName]?.[iec];
                    const iecData = isMultiMode ? iecFullData?.[mode] : iecFullData;
                    const iecRows = normalizeRows(iecData?.dashboard_summary);
                    const matchingRow = iecRows.find(r => r.description === row.description);

                    if (matchingRow) {
                        Object.keys(matchingRow).forEach(key => {
                            if (!['description', 'remark', 'key'].includes(key)) {
                                merged[`${iec}_${key}`] = matchingRow[key];
                            }
                        });
                        merged[`${iec}_color`] = matchingRow.color;
                    }
                });
                return merged;
            });

            return (
                <div style={{ width: '100%' }} className="mt-3">
                    <Spin spinning={anyLoading}>
                        <Table
                            className="dash-summary-table m-0"
                            columns={unifiedColumns}
                            dataSource={unifiedRows}
                            pagination={false}
                            size="small"
                            bordered
                            scroll={{ x: 'max-content' }}
                            style={{ width: '100%' }}
                        />
                    </Spin>
                </div>
            );
        };

        return (
            <div className="comparison-container my-3 p-4 bg-white shadow-sm rounded" style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #e0e0e0' }}>
                <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                    <b style={{ whiteSpace: 'nowrap' }}>Compare IECs:</b>
                    <div className="d-flex gap-2 flex-wrap">
                        {/* All Combined Button */}
                        <button
                            onClick={() => {
                                setSelectedIEC('ALL');
                                selectedIecRef.current = 'ALL';
                                setActiveCompareIecs(prev => ({ ...prev, [cardName]: [] }));
                                setComparisonData(prev => ({ ...prev, [cardName]: {} }));
                                getSummaryDashboard(cardName, dates, cooCosFilter, 'ALL');
                            }}
                            style={{
                                borderRadius: '50px',
                                padding: '4px 14px',
                                fontSize: '13px',
                                fontWeight: activeIecs.length === 0 ? '600' : '400',
                                cursor: 'pointer',
                                transition: 'all 0.18s ease',
                                border: activeIecs.length === 0 ? '2px solid #25dbcd' : '1.5px solid #bbb',
                                backgroundColor: activeIecs.length === 0 ? '#25dbcd' : 'transparent',
                                color: activeIecs.length === 0 ? '#0f172a' : '#333',
                                outline: 'none'
                            }}
                        >
                            ALL
                        </button>

                        <div style={{ height: '24px', width: '1px', backgroundColor: '#e0e0e0', margin: '0 4px' }} />

                        {IECOptions.filter(opt => opt.value).map(opt => {
                            const isActive = activeIecs.includes(opt.value);
                            const isDisabled = (!isActive && isMaxReached);

                            const aliasPart = opt.label?.split('-')[1]?.trim();
                            const displayLabel = aliasPart ? `${opt.value} - ${aliasPart}` : opt.value;

                            return (
                                <button
                                    key={opt.value}
                                    onClick={() => {
                                        // Toggle comparison for this IEC (any IEC can be toggled)
                                        toggleCompareIec(cardName, opt.value);
                                    }}
                                    disabled={isDisabled}
                                    style={{
                                        borderRadius: '50px',
                                        padding: '4px 14px',
                                        fontSize: '13px',
                                        fontWeight: isActive ? '600' : '400',
                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                        opacity: isDisabled ? 0.5 : 1,
                                        transition: 'all 0.18s ease',
                                        border: isActive ? '2px solid #25dbcd' : '1.5px solid #bbb',
                                        backgroundColor: isActive ? '#25dbcd' : 'transparent',
                                        color: isActive ? '#0f172a' : '#555',
                                        boxShadow: isActive ? '0 2px 8px rgba(37,219,205,0.45)' : 'none',
                                        outline: 'none',
                                        lineHeight: '1.4',
                                    }}
                                >
                                    {displayLabel}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {(() => {
                    const rawData = summaryDashboardData[cardName];
                    if (isLoading2 && !rawData) {
                        return (
                            <div className="d-flex justify-content-center p-4">
                                <Spin size="large" />
                            </div>
                        );
                    }
                    const isMultiMode = rawData && !rawData.dashboard_summary && (rawData.All || rawData.Sea || rawData.Air || rawData.Land);
                    if (isMultiMode) {
                        const availableModes = ['All', 'Sea', 'Air', 'Land'].filter(m => rawData[m]);
                        const currentMode = availableModes.includes(selectedMode) ? selectedMode : availableModes[0];

                        return (
                            <div className="multi-mode-container mt-4 mb-2">
                                <div className="mb-3">
                                    <Radio.Group
                                        value={currentMode}
                                        onChange={(e) => setSelectedMode(e.target.value)}
                                        buttonStyle="solid"
                                        size="small"
                                    >
                                        {availableModes.map(mode => (
                                            <Radio.Button key={mode} value={mode}>{mode}</Radio.Button>
                                        ))}
                                    </Radio.Group>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                    <div style={{ width: '4px', height: '18px', backgroundColor: '#25dbcd', borderRadius: '2px' }}></div>
                                    <span style={{ fontWeight: '700', fontSize: '14px', color: '#4b5563', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Mode: {currentMode}
                                    </span>
                                </div>
                                {buildUnifiedTable(currentMode)}
                            </div>
                        );
                    }
                    return buildUnifiedTable();
                })()}

                {targetRoute && (
                    <div style={{ marginTop: '10px', paddingLeft: '5px', display: 'flex', gap: '15px' }}>
                        {(cardName === 'Summary-Imp' || cardName === 'Summary-Exp') ? (
                            <a onClick={(e) => {
                                e.preventDefault();
                                downloadFullSummaryReport(cardName);
                            }} href="#" style={{ backgroundColor: '#25dbcd', color: '#0f172a', padding: '6px 16px', borderRadius: '6px', fontWeight: '700', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 8px rgba(37, 219, 205, 0.35)' }}>
                                <ArrowRightOutlined /> Download report summary
                            </a>
                        ) : (
                            <a onClick={(e) => {
                                e.preventDefault();
                                navigate(targetRoute, { state: { passedDates: serializedDates } });
                            }} href="#" style={{ backgroundColor: '#25dbcd', color: '#0f172a', padding: '6px 16px', borderRadius: '6px', fontWeight: '700', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 8px rgba(37, 219, 205, 0.35)' }}>
                                <ArrowRightOutlined /> Go to report summary
                            </a>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const getStdCertificatesDashboardData = async () => {
        const token = localStorage.getItem('token');
        setIsLoading(true);

        try {
            const response = await GetLatestStdCertificateDataService('', 3, token, selectedIEC);

            if (response) {
                if (response.data) {
                    setStdCertData(response.data);
                } else {
                    const statusMessage = {
                        'status_code': 404,
                        'expiry_status': 'Data not found'
                    }
                    setStdCertData(statusMessage);
                }
            }
            setIsLoading(false)
        }
        catch (err) {
            setIsLoading(false)
            console.log(err);
        }
    }

    const getReturnData = async () => {

        const token = localStorage.getItem('token');
        setIsLoading(true);

        try {
            const response = await GetReturnsDataService(token, "compliance", selectedIEC);
            if (response && response.data) {
                setReturnData(response.data);
            } else {
                setReturnData([]);
            }
        } catch (error) {
            console.error("Error fetching return data:", error);
            setReturnData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const viewFileDetails = (billType) => {
        navigate("/dashboard/upload/upload-files?__card__=" + billType);
    }

    // Helper: returns true if the compliance tab with the given page_desc key
    // should be visible for the current user.
    // If no COMPLIANCE rows are configured (allowedComplianceTabs === null) → show all.
    const isTabAllowed = (key) => {
        if (allowedComplianceTabs === null) return true;
        return allowedComplianceTabs.has(key);
    };


    // Returns the label when user has access, '---' when disabled (hides the feature name)
    const getTabLabel = (key, label) => {
        if (allowedComplianceTabs === null) return label;
        return allowedComplianceTabs.has(key) ? label : '---';
    };


    useEffect(() => {
        if (userDetails.role === 'admin' || userDetails.role === 'user') {
            setSelectedIEC(userDetails.iec);
        } else if (userDetails.role === 'group_head' || userDetails.role === 'superadmin') {
            setSelectedIEC('ALL'); // Default to ALL combined data
            getAdminIEC();
        }
        getStdCertificatesDashboardData();
        getReturnData();
        console.log(stdCertData);

        // Fetch RBAC to determine which compliance tabs this user can see
        const fetchComplianceRbac = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await userRbac(token);
                const items = response?.data?.data || [];
                const complianceItems = items.filter(i => i.page_type === 'COMPLIANCE');
                if (complianceItems.length === 0) {
                    // No COMPLIANCE rows configured → show all tabs (backward-compatible)
                    setAllowedComplianceTabs(null);
                } else {
                    setAllowedComplianceTabs(new Set(complianceItems.map(i => i.page_desc)));
                }
            } catch (e) {
                console.error('fetchComplianceRbac error:', e);
                setAllowedComplianceTabs(null); // fallback: show all
            }
        };
        fetchComplianceRbac();
    }, [])

    useEffect(() => {
        const openCard = Object.keys(openCollapse).find(k => openCollapse[k]);
        if (openCard) {
            getSummaryDashboard(openCard, dates);
        }
        getStdCertificatesDashboardData();
        getReturnData();
    }, [selectedIEC]);

    const dashboardReportSummaryColumns = [
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Summary',
            dataIndex: 'summary',
            key: 'summary',
            align: 'center',
            render: (text, record) => (
                <span style={{ color: record.color, fontSize: "13px" }}>
                    <b>{text}</b>
                </span>
            )
        },
    ]

    const stdCertSummaryColumns = [
        {
            title: 'File no',
            dataIndex: 'file_no',
            key: 'file_no',
            width: 120,
            render: (text, record) => (
                <span
                    style={{ fontSize: "13px", color: "#0b112e", display: "inline-block", maxWidth: "100%" }}
                    title={text} // Tooltip text to show full file no on hover
                    onMouseEnter={() => setHoveredText(text)}
                    onMouseLeave={() => setHoveredText(null)}
                >
                    <b>{hoveredText === text ? text : text.length <= 12 ? text : `${text.substring(0, 12)}...`}</b>
                </span>
            )
        },
        {
            title: 'Expiry',
            dataIndex: 'expiry_date',
            key: 'expiry_date',
            width: 110,
            render: (text, record) => (
                <span
                    style={{ fontSize: "13px", display: "inline-block", maxWidth: "100%" }}
                    title={text} // Tooltip text to show full expiry date on hover
                    onMouseEnter={() => setHoveredText(text)}
                    onMouseLeave={() => setHoveredText(null)}
                >
                    {hoveredText === text ? text : text.length <= 10 ? text : `${text.substring(0, 10)}...`}
                </span>
            )
        },
        {
            title: 'Status',
            dataIndex: 'expiry_status',
            key: 'expiry_status',
            width: 100,
            render: (text, record) => (
                <span
                    style={{ color: record.color, fontSize: "13px", display: "inline-block", maxWidth: "100%" }}
                    title={text} // Tooltip text to show full status on hover
                    onMouseEnter={() => setHoveredText(text)}
                    onMouseLeave={() => setHoveredText(null)}
                >
                    <b>{hoveredText === text ? text : text.length <= 8 ? text : `${text.substring(0, 8)}...`}</b>
                </span>
            )
        }
    ];

    const stdReturnSummaryColumns = [
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: 120,
            render: (text, record) => (
                <span
                    style={{ fontSize: "13px", color: "#0b112e", display: "inline-block", maxWidth: "100%" }}
                    title={text} // Tooltip text to show full file no on hover
                    onMouseEnter={() => setHoveredText(text)}
                    onMouseLeave={() => setHoveredText(null)}
                >
                    <b>{hoveredText === text ? text : text.length <= 7 ? text : `${text.substring(0, 7)}...`}</b>
                </span>
            )
        },
        {
            title: 'Return Date',
            dataIndex: 'return_date',
            key: 'return_date',
            width: 110,
            render: (text, record) => (
                <span
                    style={{ fontSize: "13px", display: "inline-block", maxWidth: "100%" }}
                    title={text} // Tooltip text to show full expiry date on hover
                    onMouseEnter={() => setHoveredText(text)}
                    onMouseLeave={() => setHoveredText(null)}
                >
                    {hoveredText === text ? text : text.length <= 10 ? text : `${text.substring(0, 10)}...`}
                </span>
            )
        },
        {
            title: 'Tenure',
            dataIndex: 'tenure',
            key: 'tenure',
            width: 80,
            render: (text) => (
                <span style={{ fontSize: "13px", display: "inline-block", maxWidth: "100%" }}>
                    {text}
                </span>
            )
        },
        {
            title: 'Status',
            dataIndex: 'remarks',
            key: 'remarks',
            width: 100,
            render: (text, record) => (
                <span
                    style={{ color: text ? record.color : record.color, fontSize: "13px", display: "inline-block", maxWidth: "100%" }}
                    onMouseEnter={() => setHoveredText(text)}
                    onMouseLeave={() => setHoveredText(null)}
                >
                    <b>{hoveredText === text ? text : text.length <= 10 ? text : `${text.substring(0, 10)}...`}</b>
                </span>
            )
        }
    ];

    const clearanceReportSummaryColumns = [
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Summary',
            dataIndex: 'summary',
            key: 'summary',
            align: 'center',
            render: (text, record) => (
                <span style={{ color: record.color, fontSize: "13px" }}>
                    <b>{text}</b>
                </span>
            )
        },
        {
            title: 'Days',
            dataIndex: 'days',
            key: 'days',
        },
    ]

    const handleUploadClick = () => {
        navigate("/dashboard/upload/upload-files")
    };

    const handleExcelExport = async (fileType) => {
        try {
            setIsLoading2(true);
            const token = localStorage.getItem('token');
            const reportType = (fileType === 'BOE' || fileType === 'Import') ? 'Summary-Imp' : 'Summary-Exp';
            const iec = selectedIEC || userDetails.iec || 'ALL';
            let response;
            try {
                response = await downloadDashboardReportService(reportType, iec, 'ALL');
            } catch (e1) {
                response = await downloadPendencySummary(token, fileType);
            }

            if (response && response.data) {
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const timestamp = new Date().toISOString().split('T')[0];
                link.setAttribute('download', `${fileType}_Pendency_Report_${timestamp}.xlsx`);
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                message.success('Report downloaded successfully!');
            }
        } catch (error) {
            console.error("Export failed:", error.response?.data || error.message);
            message.error("Failed to export. Please try again.");
        } finally {
            setIsLoading2(false);
        }
    };

    const handleConsultChange = (e) => {
        const { name, value } = e.target;
        setConsultationForm(prev => ({ ...prev, [name]: value }));
    };
    // console.log("consultationForm", consultationForm)
    const handleConsultSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await sendConsultationRequest(consultationForm)
            message.success("Consultation request sent successfully!");
            setConsultationForm(prev => ({
                ...prev,
                name: "",
                contact_no: "",
                subject: "",
                message: ""
            }));
            handleClose();
        } catch (err) {
            console.error(err);
            message.error("Failed to send request.");
        }
    };

    const renderInconsistencyDashboard = () => {
        const cardName = "Inconsistency";
        const rawData = summaryDashboardData[cardName];
        if (isLoading2 && (!rawData || !rawData.dashboard_summary || !rawData.headers)) {
            return (
                <div className="d-flex justify-content-center p-4">
                    <Spin size="large" />
                </div>
            );
        }
        if (!rawData || !rawData.dashboard_summary || !rawData.headers) return <div className="text-muted p-3">No data available</div>;

        const baseRows = rawData.dashboard_summary;
        const headers = rawData.headers;

        // Group head specific fields
        const isGroupHead = userDetails.role === 'group_head' && IECOptions && IECOptions.length > 0;
        const activeIecs = activeCompareIecs[cardName] || [];
        const isMaxReached = false;

        const getIecLabel = (iec) => {
            const opt = IECOptions?.find(o => o.value === iec);
            const labelMatch = opt?.label?.match(/\((.+)\)/);
            if (labelMatch) {
                const parts = labelMatch[1].split('-');
                return parts.length > 1 ? parts.pop().trim() : labelMatch[1].trim();
            }
            return iec;
        };

        const processColumns = (cols) => {
            return cols.map(col => {
                const newCol = { ...col };
                if (newCol.children) {
                    newCol.children = processColumns(newCol.children);
                } else if (newCol.textColor) {
                    newCol.render = (text) => <span style={{ color: newCol.textColor, fontWeight: 'bold' }}>{text}</span>;
                }
                return newCol;
            });
        };

        const businessUnitCol = { ...processColumns([headers[0]])[0] };
        delete businessUnitCol.fixed; // Remove fixed width for card layout
        delete businessUnitCol.width;

        // Add fixed left if side-by-side comparison is active
        if (isGroupHead && activeIecs.length > 0) {
            businessUnitCol.fixed = 'left';
            businessUnitCol.width = 150;
        }

        const categoryHeaders = headers.slice(2); // The 6 categories

        return (
            <div className="comparison-container my-3 p-3 bg-white shadow-sm rounded" style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #e0e0e0' }}>
                {isGroupHead && (
                    <div className="d-flex align-items-center mb-4 flex-wrap gap-2 px-1">
                        <b style={{ whiteSpace: 'nowrap' }}>Compare IECs:</b>
                        <div className="d-flex gap-2 flex-wrap">
                            <button
                                onClick={() => {
                                    setSelectedIEC('ALL');
                                    selectedIecRef.current = 'ALL';
                                    setActiveCompareIecs(prev => ({ ...prev, [cardName]: [] }));
                                    setComparisonData(prev => ({ ...prev, [cardName]: {} }));
                                    getSummaryDashboard(cardName, dates, cooCosFilter, 'ALL');
                                }}
                                style={{
                                    borderRadius: '50px',
                                    padding: '4px 14px',
                                    fontSize: '13px',
                                    fontWeight: activeIecs.length === 0 ? '600' : '400',
                                    cursor: 'pointer',
                                    transition: 'all 0.18s ease',
                                    border: activeIecs.length === 0 ? '2px solid #25dbcd' : '1.5px solid #bbb',
                                    backgroundColor: activeIecs.length === 0 ? '#25dbcd' : 'transparent',
                                    color: activeIecs.length === 0 ? '#0f172a' : '#333',
                                    outline: 'none'
                                }}
                            >
                                ALL
                            </button>

                            <div style={{ height: '24px', width: '1px', backgroundColor: '#e0e0e0', margin: '0 4px' }} />

                            {IECOptions.filter(opt => opt.value).map(opt => {
                                const isActive = activeIecs.includes(opt.value);
                                const isDisabled = (!isActive && isMaxReached);

                                const aliasPart = opt.label?.split('-')[1]?.trim();
                                const displayLabel = aliasPart ? `${opt.value} - ${aliasPart}` : opt.value;

                                return (
                                    <button
                                        key={opt.value}
                                        onClick={() => {
                                            // Toggle comparison for this IEC (any IEC can be toggled)
                                            toggleCompareIec(cardName, opt.value);
                                        }}
                                        disabled={isDisabled}
                                        style={{
                                            borderRadius: '50px',
                                            padding: '4px 14px',
                                            fontSize: '13px',
                                            fontWeight: isActive ? '600' : '400',
                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                            opacity: isDisabled ? 0.5 : 1,
                                            transition: 'all 0.18s ease',
                                            border: isActive ? '2px solid #25dbcd' : '1.5px solid #bbb',
                                            backgroundColor: isActive ? '#25dbcd' : 'transparent',
                                            color: isActive ? '#0f172a' : '#555',
                                            boxShadow: isActive ? '0 2px 8px rgba(37,219,205,0.45)' : 'none',
                                            outline: 'none',
                                            lineHeight: '1.4',
                                        }}
                                    >
                                        {displayLabel}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                )}

                <Row>
                    {categoryHeaders.map((category, index) => {
                        const baseCategoryChildren = processColumns(category.children);

                        let tableColumns = [businessUnitCol];
                        let tableData = [];

                        if (activeIecs.length === 0 || !isGroupHead) {
                            tableColumns = [
                                businessUnitCol,
                                ...baseCategoryChildren
                            ];
                            tableData = baseRows.map((item, idx) => ({ ...item, key: idx }));
                        } else {
                            activeIecs.forEach(iec => {
                                const iecColumns = baseCategoryChildren.map(col => {
                                    return {
                                        ...col,
                                        title: col.title,
                                        key: `${iec}_${col.dataIndex}`,
                                        dataIndex: `${iec}_${col.dataIndex}`,
                                        render: (text, record) => {
                                            const isLoadingCell = isComparingData[cardName]?.[iec];
                                            return (
                                                <span style={{ color: col.textColor || 'inherit', fontSize: '13px' }}>
                                                    <b>{isLoadingCell ? <Spin size="small" /> : (text ?? '-')}</b>
                                                </span>
                                            );
                                        }
                                    };
                                });

                                tableColumns.push({
                                    title: (
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={{ fontSize: '10px', color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={getIecLabel(iec)}>
                                                {getIecLabel(iec)}
                                            </div>
                                        </div>
                                    ),
                                    key: `${iec}_group`,
                                    children: iecColumns
                                });
                            });

                            const allBUDescs = new Set(baseRows.map(r => r.business_unit));
                            activeIecs.forEach(iec => {
                                const iecData = comparisonData[cardName]?.[iec]?.dashboard_summary || [];
                                iecData.forEach(r => allBUDescs.add(r.business_unit));
                            });

                            tableData = Array.from(allBUDescs).map((bu, idx) => {
                                const rowObj = { key: idx, business_unit: bu };
                                activeIecs.forEach(iec => {
                                    const iecData = comparisonData[cardName]?.[iec]?.dashboard_summary || [];
                                    const matchingRow = iecData.find(r => r.business_unit === bu);
                                    if (matchingRow) {
                                        Object.keys(matchingRow).forEach(key => {
                                            if (key !== 'business_unit') {
                                                rowObj[`${iec}_${key}`] = matchingRow[key];
                                            }
                                        });
                                    }
                                });
                                return rowObj;
                            });
                        }

                        const tableScroll = (isGroupHead && activeIecs.length > 0) ? { x: 'max-content' } : {};
                        const colProps = (isGroupHead && activeIecs.length > 0) ? { lg: 12, md: 12, sm: 12 } : { lg: 4, md: 6, sm: 12 };

                        return (
                            <Col {...colProps} key={index} className="mb-4">
                                <Card className="h-100 shadow-sm border">
                                    <Card.Header className="text-center" style={{ backgroundColor: "#f8f9fa", color: "black", fontSize: "14px", fontWeight: "bold" }}>
                                        {category.title}
                                    </Card.Header>
                                    <Card.Body className="p-0">
                                        <div className="table-responsive">
                                            <Table
                                                className="dash-summary-table m-0"
                                                columns={tableColumns}
                                                dataSource={tableData}
                                                pagination={false}
                                                size="small"
                                                bordered
                                                loading={isLoading2 && activeIecs.length === 0}
                                                scroll={tableScroll}
                                            />
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        );
    };


    return (
        <Fragment>

            <div className="justify-content-between align-items-center flex-wrap mb-2 gap-2">

                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {modalType} Information
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {modalType === "Consultation" ? (
                            <Form onSubmit={handleConsultSubmit}>
                                <Form.Group className="mb-2">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={consultationForm.name}
                                        onChange={handleConsultChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="email"
                                        value={consultationForm.email}
                                        onChange={handleConsultChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="col-md-12 form-group">
                                    <Form.Label>Contact No</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="contact_no"
                                        value={consultationForm.contact_no}
                                        onChange={handleConsultChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Subject</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="subject"
                                        value={consultationForm.subject}
                                        onChange={handleConsultChange}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="message"
                                        value={consultationForm.message}
                                        onChange={handleConsultChange}
                                        required
                                    />
                                </Form.Group>

                                <Button variant="primary" type="submit" className="mt-2 w-100">
                                    Send Consultation Request
                                </Button>
                            </Form>
                        ) : modalType === "IEC" ? (
                            <>
                                <p>IEC: {userDetails.iec}</p>
                                <p>Name: {userDetails.name}</p>
                                <p>Expiry Date: {expiryDate}</p>
                                <p>Days left until expiry: {daysLeft}</p>
                            </>
                        ) : (
                            <>
                                {stdCertData[modalType] && stdCertData[modalType].length > 0 ? (
                                    <>
                                        <p>File No: <b>{stdCertData[modalType][0]?.file_no || 'N/A'}</b></p>
                                        <p>Expiry Date: {stdCertData[modalType][0]?.expiry_date || 'N/A'}</p>
                                        <p>Status: <b style={{ color: stdCertData[modalType][0]?.color || 'inherit' }}>
                                            {stdCertData[modalType][0]?.expiry_status || 'N/A'}
                                        </b></p>
                                    </>
                                ) : (
                                    <p>No {modalType} data available</p>
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        {/* <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button> */}
                    </Modal.Footer>
                </Modal>
            </div>

            {/* IMP DUTY RATE Modal */}
            <Modal show={showImpDutyModal} onHide={handleImpDutyModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Search Import Benefit Report</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleImpDutySearch}>
                        <Form.Group className="mb-3">
                            <Form.Label>HS Code</Form.Label>
                            <AutoComplete
                                style={{ width: '100%' }}
                                options={impDutyHscodeOptions}
                                value={impDutyHscode}
                                onChange={handleImpDutyHscodeChange}
                                onSelect={handleImpDutyHscodeSelect}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            >
                                <Input placeholder="Enter 8-digit HS Code" />
                            </AutoComplete>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Assessable Value</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter Assessable Value"
                                value={impDutyAssessableValue}
                                onChange={(e) => setImpDutyAssessableValue(e.target.value)}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="w-100" disabled={impDutyLoading}>
                            {impDutyLoading ? <Spin size="small" /> : 'Search'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* <Row>
                <Col lg="4" md="6" sm="12">
                    <Card>
                        <Card.Body>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <span><b>RCMC</b></span>

                                </div>
                                <div>
                                    <span className="badge bg-primary">View</span>
                                </div>
                            </div>

                            <div className="justify-content-between mt-2">
                                <div>
                                    <Row>
                                        <Col lg="5" md="5" sm="5">
                                            <h5>File no.</h5>
                                        </Col>
                                        
                                        <Col lg="6" md="6" sm="6">
                                            <h5 className="counter">: 40372456390</h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="5" md="5" sm="5">
                                            <h5>Issue Date</h5>
                                        </Col>
                                        
                                        <Col lg="6" md="6" sm="6">
                                            <h5 className="counter">: 2nd Jan 2024</h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="5" md="5" sm="5">
                                            <h5>Expiry Date</h5>
                                        </Col>
                                        
                                        <Col lg="6" md="6" sm="6">
                                            <h5 className="counter">: 2nd Jan 2024</h5>
                                        </Col>
                                    </Row>
                                     
                                    No action required
                                </div>
                                
                            </div>

                           
                            <div className="mt-3">
                                <Progress softcolors="success" color="success" className="shadow-none w-100" value={100} minvalue={0} maxvalue={100} style={{ height: "6px" }} />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg="4" md="6" sm="12">
                    <Card>
                        <Card.Body>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <span><b>EH</b></span>
                                </div>
                                <div>
                                    <span className="badge bg-primary">View</span>
                                </div>
                            </div>  
                            <div className="justify-content-between mt-2">
                                <div>
                                    <Row>
                                        <Col lg="5" md="5" sm="5">
                                            <h5>File no.</h5>
                                        </Col>
                                        
                                        <Col lg="6" md="6" sm="6">
                                            <h5 className="counter">: 40372456390</h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="5" md="5" sm="5">
                                            <h5>Issue Date</h5>
                                        </Col>
                                        
                                        <Col lg="6" md="6" sm="6">
                                            <h5 className="counter">: 2nd Jan 2024</h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="5" md="5" sm="5">
                                            <h5>Expiry Date</h5>
                                        </Col>
                                        
                                        <Col lg="6" md="6" sm="6">
                                            <h5 className="counter">: 2nd Jan 2024</h5>
                                        </Col>
                                    </Row>
                                     
                                    
                                    No action required
                                </div>
                                
                            </div>
                            <div className="mt-3">
                                <Progress softcolors="primary" color="primary" className="shadow-none w-100" value={100} minvalue={0} maxvalue={100} style={{ height: "6px" }} />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                </Row> */}

            {(userDetails.role === 'admin' || userDetails.role === 'user' || userDetails.role === 'group_head' || userDetails.role === 'superadmin') && <>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 style={{ margin: 0, fontWeight: 700, color: '#1e293b' }}>Classic Compliance Dashboard</h4>
                    <Tooltip title="Switch between the Classic and New dashboard — you can switch back anytime">
                        <Segmented
                            className="cip-dash-switch"
                            size="middle"
                            value="classic"
                            onChange={(val) => {
                                if (val === 'new') {
                                    localStorage.setItem('preferredDashboard', 'new');
                                    navigate('/dashboard');
                                }
                            }}
                            options={[
                                { label: 'Classic', value: 'classic' },
                                { label: 'New', value: 'new' },
                            ]}
                        />
                    </Tooltip>
                </div>
                <Row className="mb-2 d-flex justify-content-between">
                    <Col lg={3} md={3} xs={12} className="text-end">
                        <Button className="w-100" variant="primary" onClick={() => handleShow("IEC")}>IEC: {userDetails.iec}</Button>
                    </Col>
                    <Col lg={3} md={3} xs={12} className="text-nowrap">
                        <Button className="w-100" variant="primary" onClick={() => handleShow("EH")} > EH{stdCertData['EH']?.[0]?.file_no ? `: ${stdCertData['EH'][0].file_no}` : ''}</Button>
                    </Col>
                    <Col lg={3} md={3} xs={12} className="text-nowrap">
                        <Button className="w-100" variant="primary" onClick={() => handleShow("AEO")}>AEO{stdCertData['AEO']?.[0]?.file_no ? `: ${stdCertData['AEO'][0].file_no}` : ''}</Button>
                    </Col>
                    <Col lg={3} md={3} xs={12} className="text-nowrap">
                        <Button className="w-100" variant="primary" onClick={() => handleShow("Returns")}>Returns {stdCertData['Returns']?.[0]?.file_no ? `: ${stdCertData['Returns'][0].file_no}` : ''}</Button>
                    </Col>
                </Row>

                {userDetails.role !== 'group_head' && (
                    <Row className="mt-3">
                        <Col className="col-4">
                            <Card className="std-cert-card">
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <div><span><b style={{ color: 'black' }}>RCMC</b></span></div>
                                        <div>
                                            <a style={{ cursor: "pointer" }} onClick={() => viewFileDetails("RCMC")}>
                                                <span className="badge bg-primary">View</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <Table
                                            className="std-cert-table"
                                            width={100}
                                            columns={stdCertSummaryColumns}
                                            dataSource={stdCertData['RCMC']}
                                            pagination={false}
                                            loading={isLoading}
                                            scroll={{ x: 'max-content' }}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col className="col-4">
                            <Card className="std-cert-card">
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <div><span><b style={{ color: 'black' }}>Returns</b></span></div>
                                        <div>
                                            <a style={{ cursor: "pointer" }} onClick={() => viewFileDetails("RETURNS")}>
                                                <span className="badge bg-primary">View</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <Table
                                            className="std-cert-table"
                                            width={100}
                                            columns={stdReturnSummaryColumns}
                                            dataSource={returnData}
                                            pagination={false}
                                            loading={isLoading}
                                            scroll={{ x: 'max-content' }}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col className="col-4">
                            <Card className="std-cert-card">
                                <Card.Body>
                                    <div className="d-flex justify-content-between">
                                        <div><span><b style={{ color: 'black' }}>DSC</b></span></div>
                                        <div>
                                            <a style={{ cursor: "pointer" }} onClick={() => viewFileDetails("DSC")}>
                                                <span className="badge bg-primary">View</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <Table
                                            className="std-cert-table"
                                            width={100}
                                            columns={stdCertSummaryColumns}
                                            dataSource={stdCertData['DSC']}
                                            pagination={false}
                                            loading={isLoading}
                                            scroll={{ x: 'max-content' }}
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                )}
            </>}

            {(userDetails.role === 'admin' || userDetails.role === 'user' || userDetails.role === 'group_head' || userDetails.role === 'superadmin') && <>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center gap-3">
                        <p className="text-primary mb-0">Compliances</p>

                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span style={{ fontSize: '14px' }}>Currency</span>
                        <Radio.Group
                            value={selectedCurrency}
                            onChange={(e) => setSelectedCurrency(e.target.value)}
                            buttonStyle="solid"
                            size="small"
                        >
                            <Radio.Button value="INR">INR</Radio.Button>
                            <Radio.Button value="USD">USD</Radio.Button>
                        </Radio.Group>
                        <span style={{ fontSize: '14px', marginLeft: '10px' }}>Please select duration</span>
                        <Radio.Group
                            value={mode}
                            onChange={(e) => {
                                setMode(e.target.value);
                                setDates([]);
                                setSelectedYear(null);
                                setIsValid(false);
                            }}
                        >
                            <Radio value="year">Year</Radio>
                            <Radio value="dates">Dates</Radio>
                        </Radio.Group>
                        {mode === 'year' && (
                            <DatePicker
                                picker="year"
                                placeholder="Select Year"
                                value={selectedYear}
                                onChange={handleYearChange}
                            />
                        )}
                        {mode === 'dates' && (
                            <DatePicker.RangePicker
                                value={dates}
                                onChange={(value) => {
                                    setDates(value);
                                    setIsValid(!!value);

                                    // Auto-refresh data if a card is open when date range changes
                                    if (value && value.length === 2) {
                                        const openCard = Object.keys(openCollapse).find(k => openCollapse[k]);
                                        if (openCard) {
                                            getSummaryDashboard(openCard, value);
                                            refreshActiveComparisons(openCard, value);
                                            message.success("Selection updated.");
                                        }
                                    }
                                }}
                                allowClear
                            />
                        )}
                        <Button
                            variant="primary"
                            className="custom-submit-btn"
                            onClick={handleSubmit}
                        >
                            <SearchOutlined />
                        </Button>
                    </div>
                </div>

                <Row className="mt-2 btns-row" style={{ justifyContent: "center", alignItems: "center" }}>
                    {/* <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" onClick={() => showCollapseCard('D2D')} aria-controls="D2D" aria-expanded={openCollapse['D2D']}>
                            D2D &nbsp;
                            {openCollapse['D2D'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>  */}
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('Summary-Imp')} onClick={() => showCollapseCard('Summary-Imp')} aria-controls="Summary-Imp" aria-expanded={openCollapse['Summary-Imp']}>
                            {getTabLabel('Summary-Imp', 'Summary-Imp')} &nbsp;
                            {openCollapse['Summary-Imp'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('Summary-Exp')} onClick={() => showCollapseCard('Summary-Exp')} aria-controls="Summary-Exp" aria-expanded={openCollapse['Summary-Exp']}>
                            {getTabLabel('Summary-Exp', 'Summary-Exp')} &nbsp;
                            {openCollapse['Summary-Exp'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('EDPMS')} onClick={() => showCollapseCard('EDPMS')} aria-controls="EDPMS" aria-expanded={openCollapse['EDPMS']}>
                            {getTabLabel('EDPMS', 'EDPMS')} &nbsp;
                            {openCollapse['EDPMS'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('IDPMS')} onClick={() => showCollapseCard('IDPMS')} aria-controls="IDPMS" aria-expanded={openCollapse['IDPMS']}>
                            {getTabLabel('IDPMS', 'IDPMS')} &nbsp;
                            {openCollapse['IDPMS'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('DBK-AIR')} onClick={() => showCollapseCard('DBK-AIR')} aria-controls="DBK-AIR" aria-expanded={openCollapse['DBK-AIR']}>
                            {getTabLabel('DBK-AIR', 'DBK-AIR')} &nbsp;
                            {openCollapse['DBK-AIR'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('IGST-Refund')} onClick={() => showCollapseCard('IGST-Refund')} aria-controls="IGST-Refund" aria-expanded={openCollapse['IGST-Refund']}>
                            {getTabLabel('IGST-Refund', 'IGST refund')} &nbsp;
                            {openCollapse['IGST-Refund'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                </Row>

                <Row className="justify-content-center">
                    <Col lg="12" md="12" sm="12">
                        <Collapse in={openCollapse["Summary-Imp"]} >
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>Summary-Imp</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("Summary-Imp")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: '6px' }}>
                                        <a href="#" onClick={(e) => { e.preventDefault(); handleExcelExport("Import"); }} style={{ backgroundColor: '#25dbcd', color: '#0f172a', padding: '6px 16px', borderRadius: '6px', fontWeight: '700', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 8px rgba(37, 219, 205, 0.35)' }}><ArrowRightOutlined /> Download report summary</a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["IDPMS"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>IDPMS</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("IDPMS")}
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["Summary-Exp"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>Summary-Exp</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("Summary-Exp")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: '6px' }}>
                                        <a href="#" onClick={(e) => { e.preventDefault(); handleExcelExport("Export"); }} style={{ backgroundColor: '#25dbcd', color: '#0f172a', padding: '6px 16px', borderRadius: '6px', fontWeight: '700', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 8px rgba(37, 219, 205, 0.35)' }}><ArrowRightOutlined /> Download report summary</a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["EDPMS"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>EDPMS</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("EDPMS")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/brc-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["DBK-AIR"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>DBK-AIR</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("DBK-AIR")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/drawback-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["IGST-Refund"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>IGST-Refund</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("IGST-Refund")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/igst-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>
                    </Col>
                </Row>

                <Row className="btns-row" style={{ justifyContent: "center", alignItems: "center" }}>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button_row_two" disabled={!isTabAllowed('RODTEP-Exp')} onClick={() => showCollapseCard('RODTEP-Exp')} aria-controls="RODTEP-Exp" aria-expanded={openCollapse['RODTEP-Exp']}>
                            {getTabLabel('RODTEP-Exp', 'RODTEP - EXP')} &nbsp;
                            {openCollapse['RODTEP-Exp'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button_row_two" disabled={!isTabAllowed('Rodtep-Util')} onClick={() => showCollapseCard('Rodtep-Util')} aria-controls="Rodtep-Util" aria-expanded={openCollapse['Rodtep-Util']}>
                            {getTabLabel('Rodtep-Util', 'RODTEP - IMP')} &nbsp;
                            {openCollapse['Rodtep-Util'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button_row_two" disabled={!isTabAllowed('AdvAuth-EO')} onClick={() => showCollapseCard('AdvAuth-EO')} aria-controls="AdvAuth-EO" aria-expanded={openCollapse['AdvAuth-EO']}>
                            {getTabLabel('AdvAuth-EO', 'Adv. Auth-EO')} &nbsp;
                            {openCollapse['AdvAuth-EO'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button_row_two" disabled={!isTabAllowed('AdvAuth-Utilization')} onClick={() => navigate('/dashboard/reports/advauth-import-report')}>
                            {/* onClick={() => showCollapseCard('AdvAuth-Utilization')} aria-controls="AdvAuth-Utilization" aria-expanded={openCollapse['AdvAuth-Utilization']} */}
                            {getTabLabel('AdvAuth-Utilization', 'AdvAuth-IMP')} &nbsp;
                            {openCollapse['AdvAuth-Utilization'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>

                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button_row_two" disabled={!isTabAllowed('AdvAuthExcessImportLiab')} onClick={() => navigate('/dashboard/reports/advauth-excess-import-report')}>
                            {/* onClick={() => showCollapseCard('AdvAuthExcessImportLiab')} aria-controls="AdvAuthExcessImportLiab" aria-expanded={openCollapse['AdvAuthExcessImportLiab']} */}
                            {getTabLabel('AdvAuthExcessImportLiab', 'AdvAuth-Liab')} &nbsp;
                            {openCollapse['AdvAuthExcessImportLiab'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button_row_two" disabled={!isTabAllowed('EPCG-Auth-EO')} onClick={() => showCollapseCard('EPCG-Auth-EO')} aria-controls="EPCG-Auth-EO" aria-expanded={openCollapse['EPCG-Auth-EO']}>
                            {getTabLabel('EPCG-Auth-EO', 'EPCG Auth-EO')} &nbsp;
                            {openCollapse['EPCG-Auth-EO'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col lg="12" md="12" sm="12">

                        <Collapse in={openCollapse["RODTEP-Exp"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>RODTEP-Exp</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("RODTEP-Exp")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/rodtep-export-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["AdvAuth-EO"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>AdvAuth-EO</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("AdvAuth-EO")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/advauth-export-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["EPCG-Auth-EO"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>EPCG-Auth-EO</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("EPCG-Auth-EO")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/epcg-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["AdvAuthExcessImportLiab"]}>
                            <Card>
                                {/* <Card.Header style={{ color: "black" }}><b>🚧 Coming soon… This feature is under development.</b></Card.Header> */}
                                <Card.Header style={{ color: "black" }}><b>AdvAuthExcessImportLiab</b></Card.Header>
                                {/* <ul className="iq-header-sub-menu list-unstyled " id="AdvAuthExcessImportLiab">
                                    <Table
                  className="dash-summary-table"
                                        width={100}
                                        columns={dashboardReportSummaryColumns}
                                        dataSource={summaryDashboardData["AdvAuthExcessImportLiab"] && summaryDashboardData["AdvAuthExcessImportLiab"]["dashboard_summary"]}
                                        pagination={false}
                                        loading={isLoading2}
                                    />
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={() => navigate('/dashboard/reports/advauth-excess-import-report')} href="#"> <ArrowRightOutlined />  Go to report summary</a>
                                    </p>
                                </ul> */}
                                <ul className="iq-header-sub-menu list-unstyled " id="AdvAuthExcessImportLiab">
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px", }}>
                                        <a onClick={() => navigate('/dashboard/reports/advauth-excess-import-report')} href="#"> <ArrowRightOutlined />  Go to report summary</a>
                                    </p>
                                </ul>
                            </Card>
                        </Collapse>
                        <Collapse in={openCollapse["AdvAuth-Utilization"]} >
                            <Card>

                                {/* <Card.Header style={{ color: "black" }}><b>🚧 Coming soon… This feature is under development.</b></Card.Header> */}
                                <Card.Header style={{ color: "black" }}><b>AdvAuth-Utilization</b></Card.Header>
                                {/* <ul className="iq-header-sub-menu list-unstyled " id="AdvAuth-Utilization">
                                    <Table
                  className="dash-summary-table"
                                        width={100}
                                        columns={dashboardReportSummaryColumns}
                                        dataSource={summaryDashboardData["AdvAuth-Utilization"] && summaryDashboardData["AdvAuth-Utilization"]["dashboard_summary"]}
                                        pagination={false}
                                        loading={isLoading2}
                                    />
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={() => navigate('/dashboard/reports/advauth-import-report')} href="#"> <ArrowRightOutlined />  Go to report summary</a>
                                    </p>
                                </ul> */}
                                <ul className="iq-header-sub-menu list-unstyled " id="AdvAuth-Utilization">
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px", }}>
                                        <a onClick={() => navigate('/dashboard/reports/advauth-import-report')} href="#"> <ArrowRightOutlined />  Go to report summary</a>
                                    </p>
                                </ul>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["Rodtep-Util"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>Rodtep-Util</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("Rodtep-Util")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/rodtep-import-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>
                    </Col>
                </Row>

                <Row className="btns-row" style={{ justifyContent: "center", alignItems: "center" }}>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('CCR')} onClick={() => navigate('/dashboard/reports/ccr')} aria-controls="CCR" aria-expanded={openCollapse['CCR']}>
                            CCR&nbsp;
                            {openCollapse['CCR'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('FTA-Opportunity')} onClick={() => showCollapseCard(['FTA-Opportunity', 'FTA-Applicability'])} aria-controls="FTA-Opportunity" aria-expanded={openCollapse['FTA-Opportunity'] || openCollapse['FTA-Applicability']}>
                            {getTabLabel('FTA-Opportunity', 'FTA')} &nbsp;
                            {openCollapse['FTA-Opportunity'] || openCollapse['FTA-Applicability'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('TAT-ExportClearance')} onClick={() => showCollapseCard('TAT-ExportClearance')} aria-controls="TAT-ExportClearance" aria-expanded={openCollapse['TAT-ExportClearance']}>
                            {getTabLabel('TAT-ExportClearance', 'ClearanceTAT-EXP')} &nbsp;
                            {openCollapse['TAT-ExportClearance'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('TAT-ImportClearance')} onClick={() => showCollapseCard('TAT-ImportClearance')} aria-controls="TAT-ImportClearance" aria-expanded={openCollapse['TAT-ImportClearance']}>
                            {getTabLabel('TAT-ImportClearance', 'ClearanceTAT-IMP')} &nbsp;
                            {openCollapse['TAT-ImportClearance'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('Bond-Utilization')} onClick={() => showCollapseCard('Bond-Utilization')} aria-controls="EDPMS" aria-expanded={openCollapse['EDPMS']}>
                            {getTabLabel('Bond-Utilization', 'Bond-Utilization')} &nbsp;
                            {openCollapse['Bond-Utilization'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button" disabled={!isTabAllowed('IMP-DUTY-RATE')} onClick={handleImpDutyModalOpen}>
                            {getTabLabel('IMP-DUTY-RATE', 'IMP. DUTY RATE')} &nbsp;
                            <DownOutlined />
                        </Button>
                    </Col>
                </Row>

                <Row className="justify-content-center">
                    <Col lg="12" md="12" sm="12">
                        <Collapse in={openCollapse["FTA-Opportunity"]} >
                            <Card className="mb-3">
                                <Card.Header style={{ color: "black", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <b>FTA-Opportunity-I</b>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontSize: '12px', fontWeight: '500' }}>Remark :</span>
                                            <Select
                                                value={categoryRemarkFilter}
                                                onChange={(value) => {
                                                    setCategoryRemarkFilter(value);
                                                    getSummaryDashboard("FTA-Opportunity", null, undefined, null, value);
                                                }}
                                                style={{ width: 130 }}
                                                size="small"
                                            >
                                                <Select.Option value="ALL">All</Select.Option>
                                                <Select.Option value="FTA Applicable and Availed">Availed</Select.Option>
                                                <Select.Option value="FTA Applicable but Not Availed">Not Availed</Select.Option>
                                            </Select>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ fontSize: '12px', fontWeight: '500' }}>COO = COS :</span>
                                            <Select
                                                value={cooCosFilter}
                                                onChange={(value) => {
                                                    setCooCosFilter(value);
                                                    getSummaryDashboard("FTA-Opportunity", null, value);
                                                }}
                                                style={{ width: 90 }}
                                                size="small"
                                            >
                                                <Select.Option value="ALL">All</Select.Option>
                                                <Select.Option value="TRUE">True</Select.Option>
                                                <Select.Option value="FALSE">False</Select.Option>
                                            </Select>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("FTA-Opportunity")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "8px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/fta-opp-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>
                        <Collapse in={openCollapse["FTA-Applicability"]} >
                            <Card className="mb-3">
                                <Card.Header style={{ color: "black" }}><b>FTA-Applicability-E</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("FTA-Applicability")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "8px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/fta-applicability-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>


                        <Collapse in={openCollapse["TAT-ImportClearance"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}>
                                    <b>TAT-ImportClearance</b>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("TAT-ImportClearance")}
                                    <p
                                        style={{
                                            paddingLeft: "5px",
                                            paddingRight: "5px",
                                            marginTop: "8px",
                                            marginBottom: "0px",
                                        }}
                                    >
                                        <a
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate(
                                                    "/dashboard/reports/clearance-time-import-report",
                                                    { state: { passedDates: serializedDates } }
                                                );
                                            }}
                                            href="#"
                                        >
                                            <ArrowRightOutlined /> Go to report summary
                                        </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["TAT-ExportClearance"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}>
                                    <b>TAT-ExportClearance</b>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("TAT-ExportClearance")}
                                    <p
                                        style={{
                                            paddingLeft: "5px",
                                            paddingRight: "5px",
                                            marginTop: "8px",
                                            marginBottom: "0px",
                                        }}
                                    >
                                        <a
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate(
                                                    "/dashboard/reports/clearance-time-export-report",
                                                    { state: { passedDates: serializedDates } }
                                                );
                                            }}
                                            href="#"
                                        >
                                            <ArrowRightOutlined /> Go to report summary
                                        </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>

                        <Collapse in={openCollapse["Bond-Utilization"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>Bond-Utilization</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderCompareIecs("Bond-Utilization")}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/bond-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>
                    </Col>
                </Row>
                <Row className="btns-row" style={{ justifyContent: "center", alignItems: "center" }}>
                    <Col lg="2" md="4" className="mb-2">
                        <Button className="custom-button_row_two" disabled={!isTabAllowed('Inconsistency')} onClick={() => showCollapseCard('Inconsistency')} aria-controls="Inconsistency" aria-expanded={openCollapse['Inconsistency']}>
                            {getTabLabel('Inconsistency', 'Inconsistency Report')} &nbsp;
                            {openCollapse['Inconsistency'] ? <UpOutlined /> : <DownOutlined />}
                        </Button>
                    </Col>


                </Row>

                <Row className="justify-content-center">
                    <Col lg="12" md="12" sm="12">
                        <Collapse in={openCollapse["Inconsistency"]}>
                            <Card>
                                <Card.Header style={{ color: "black" }}><b>Inconsistency Report</b></Card.Header>
                                <Card.Body className="p-0">
                                    {renderInconsistencyDashboard()}
                                    <p style={{ paddingLeft: '5px', paddingRight: '5px', marginTop: '8px', marginBottom: "0px" }}>
                                        <a onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/dashboard/reports/inconsistency-report', { state: { passedDates: serializedDates } });
                                        }} href="#" >  <ArrowRightOutlined /> Go to report summary </a>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Collapse>
                    </Col>
                </Row>
            </>}
            <hr />
        </Fragment>
    )
})

Index.displayName = "Index"
export default Index